import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class LocationsRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    mastersCartons: number;
    @ApiProperty()
    stockTypeStatus: string;
    @ApiProperty()
    varientId?: number;
    @ApiProperty()
    packStyleId?:number; 
    @ApiProperty()
    role?: string;
}